import React, { useMemo, useCallback } from "react";

import Linkify from "react-linkify";

import { PicklistValue } from "./styles";
import { FieldValue } from "./Values/styles";

type Props = {
  oldValue: Array<string> | string;
  newValue: Array<string> | string;
  componentDecorator: (
    href: string,
    text: string,
    key: number,
  ) => React.ReactNode;
};

const Picklists = ({ oldValue, newValue, componentDecorator }: Props) => {
  const diff = useMemo(() => {
    if (!oldValue) {
      return [];
    }
    const newValueSet = new Set(
      Array.isArray(newValue) ? newValue : [newValue || ""],
    );
    return Array.isArray(oldValue)
      ? oldValue.filter((value) => !newValueSet.has(value))
      : newValueSet.has(oldValue)
        ? []
        : [oldValue];
  }, [oldValue, newValue]);

  const renderPicklistValues = useCallback(
    (values: Array<string>) => {
      return values.map((value, index) => (
        <React.Fragment key={`${value}-${index}`}>
          <Linkify componentDecorator={componentDecorator}>{value}</Linkify>
          {index < values.length - 1 && <>,&nbsp;</>}
        </React.Fragment>
      ));
    },
    [componentDecorator],
  );

  return (
    <>
      {diff.length > 0 && (
        <FieldValue old>{renderPicklistValues(diff)}</FieldValue>
      )}
      {newValue && (
        <PicklistValue>
          {Array.isArray(newValue) ? (
            renderPicklistValues(newValue)
          ) : (
            <Linkify componentDecorator={componentDecorator}>
              {newValue}
            </Linkify>
          )}
        </PicklistValue>
      )}
    </>
  );
};

export default Picklists;
